export enum RentType {
    Daily = "Daily",
    Driver = "With driver",
    Purchase = "With redemption",
    Insured = "Insured"
}